import { MouseEvent, useState } from 'react';
import EditorCollapseIcon from '@atlaskit/icon/glyph/editor/collapse';
import EditorExpandIcon from '@atlaskit/icon/glyph/editor/expand';
import { EditorAppearance } from '@atlaskit/editor-core/editor';
import { actionButton } from './BreadcrumbActions';
import Tooltip from '@atlaskit/tooltip';

interface FullWidthToggleProps {
  appearance: EditorAppearance;
  onFullWidthChange: (fullWidthMode: boolean) => void;
}

export const FullWidthToggle = ({
  appearance,
  onFullWidthChange
}: FullWidthToggleProps) => {
  const [fullWidthMode, setFullWidthMode] = useState(
    appearance === 'full-width'
  );

  const toggleFullWidthMode = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    setFullWidthMode((prevMode) => {
      onFullWidthChange(!prevMode);
      return !prevMode;
    });
  };

  return (
    <Tooltip
      content={fullWidthMode ? 'Make page fixed-width' : 'Make page full-width'}
      position="bottom"
    >
      <button css={actionButton} onClick={toggleFullWidthMode}>
        {fullWidthMode ? (
          <EditorCollapseIcon label="Make page fixed width" />
        ) : (
          <EditorExpandIcon label="Make page full width" />
        )}
      </button>
    </Tooltip>
  );
};
